import { render, staticRenderFns } from "./FInfo.vue?vue&type=template&id=9aa5c234&scoped=true"
import script from "./FInfo.vue?vue&type=script&lang=js"
export * from "./FInfo.vue?vue&type=script&lang=js"
import style0 from "./FInfo.vue?vue&type=style&index=0&id=9aa5c234&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa5c234",
  null
  
)

export default component.exports